import { useState } from 'react';
import { faqData } from '@/mocks/home';
import SEOSchema from '@/components/feature/SEOSchema';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const faqSchema = {
    mainEntity: faqData.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-100">
      <SEOSchema type="FAQPage" data={faqSchema} />
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">常见问题</h2>
          <p className="text-foreground-600 text-base">快速了解云开体育的常见疑问</p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, idx) => (
            <div
              key={idx}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
              >
                <span className="font-heading text-base font-semibold text-foreground-900 pr-4">{faq.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 text-lg transition-transform flex-shrink-0 ${
                    openIdx === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIdx === idx && (
                <div className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}